import React from 'react'
import {
  downloadLinkCreator,
  fireClevertapEvent,
  isMobileApp,
  fireClevertapUIAction,
  getCommonClevertapParams,
  triggerClevertap,
  isEmpty,
  callDownlaodEticketAPI,
  callDownloadGSTInvoiceAPI
} from 'AccountsUtils'
import { ROR_DOWNLOAD_E_TICKET_SWITCH } from 'AccountsConstants/language/trips'
import Emailer from '../Common/Emailer'

const ToolItem = ({ data, isVasOpted = false, isPWA, tripId, setEmailerModal, emailerModal,
  emailerSuccessModal, setEmailerSuccessModal, vas, abData, tripDetails }) => {
  const { text, href, action, neg, eText, eHref } = data
  const dispatcher = e => {
    fireClevertapEvent(`${text.toLowerCase().replace(' ', '_')}_clicked`, { trip_id: tripId })
    if (text === 'Cancel' || text === 'Cancel flights') {
      fireClevertapUIAction({
        action_name: 'Cancellation Clicked',
        alternate_refund_cookie: abData && abData.alternate_refund,
        trip_id: `id_${tripId}`
      })
    }
    e.preventDefault()
    e.stopPropagation()
    switch (action) {
      case 'download':
        downloadLinkCreator(href)
        break
      // case 'download_view':
      //   downloadLinkCreator(href, isMobileApp())
      //   break
      case 'send_email':
        setEmailerModal(true)
        break
      case 'download_eticket':
        if (ROR_DOWNLOAD_E_TICKET_SWITCH) {
          downloadLinkCreator(href, isMobileApp())
        } else {
          callDownlaodEticketAPI(tripId)
        }
        break
      case 'download_invoice':
      case 'download_view':
        callDownloadGSTInvoiceAPI(tripId)
        break
      default:
      case 'route_out':
        if (data.vas === 'amend_insurance') {
          const flights = (tripDetails &&
            tripDetails.airInfo &&
            tripDetails.airInfo.flightDetails) || []
          const airlines = []
          const flightNumbers = []
          flights.forEach((flightItem = {}) => {
            if (!isEmpty(flightItem.segmentDetails)) {
              flightItem.segmentDetails.forEach(segment => {
                airlines.push(segment.operatingAirline)
                flightNumbers.push(segment.flightNumber)
              })
            }
          })
          const payload = {
            ...getCommonClevertapParams(),
            action_name: 'Reschedule clicked',
            trip_id: tripId,
            airlines: airlines.join(','),
            flightNumbers: flightNumbers.join(',')
          }
          triggerClevertap('Air_UI_Action', payload)
        }
        window.location.href = href || window.location.href
        break
    }
  }
  return (
    <React.Fragment>
      <li className="flex-1 grey-on-hover pt-2 pb-2">
        <a className="flex flex-center flex-middle no-decoration" href={href} onClick={dispatcher}>
          <div className={`flex flex-center flex-middle ${isPWA ? 'flex-column' : ''}`}>
            <data.icon fill={`${data.color ? data.color : '#3669C9'}`} />
            <div className={`${isPWA ? 'flex-1 pt-1' : ''} ${neg ? 'c-red' : 'c-blue'}`}>
              <p className={`${isPWA ? 'fs-11' : 'fs-caption-2 pl-2 pr-2'} fs-11 fw-500 us-text`}>
                {text}
              </p>
            </div>
          </div>
        </a>
      </li>
      <If condition={emailerModal}>
        <Emailer
          toggleModal={emailerModal}
          emailerText={eText}
          href={eHref}
          setToggleModal={setEmailerModal}
          emailerSuccessModal={emailerSuccessModal}
          setEmailerSuccessModal={setEmailerSuccessModal}
          tripId={tripId}
        />
      </If>
    </React.Fragment>
  )
}

// fireEvent('A_CALCULATE_REFUND_CLICKED', clevertapData)
export default ToolItem
